<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.57414 12.3818C6.62173 12.5045 6.6931 12.6167 6.78414 12.7118L11.7841 17.7118C11.8774 17.805 11.9881 17.879 12.1099 17.9294C12.2317 17.9799 12.3623 18.0059 12.4941 18.0059C12.7604 18.0059 13.0158 17.9001 13.2041 17.7118C13.2974 17.6185 13.3713 17.5078 13.4218 17.386C13.4723 17.2642 13.4982 17.1336 13.4982 17.0018C13.4982 16.7355 13.3924 16.4801 13.2041 16.2918L9.90414 13.0018H17.4941C17.7594 13.0018 18.0137 12.8964 18.2012 12.7089C18.3888 12.5213 18.4941 12.267 18.4941 12.0018C18.4941 11.7366 18.3888 11.4822 18.2012 11.2947C18.0137 11.1071 17.7594 11.0018 17.4941 11.0018H9.90414L13.2041 7.71177C13.2979 7.6188 13.3723 7.5082 13.423 7.38634C13.4738 7.26449 13.4999 7.13378 13.4999 7.00177C13.4999 6.86976 13.4738 6.73905 13.423 6.61719C13.3723 6.49533 13.2979 6.38473 13.2041 6.29177C13.1112 6.19804 13.0006 6.12364 12.8787 6.07288C12.7569 6.02211 12.6262 5.99597 12.4941 5.99597C12.3621 5.99597 12.2314 6.02211 12.1096 6.07288C11.9877 6.12364 11.8771 6.19804 11.7841 6.29177L6.78414 11.2918C6.6931 11.3869 6.62173 11.499 6.57414 11.6218C6.47412 11.8652 6.47412 12.1383 6.57414 12.3818Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'BackIcon',
};
</script>
